export const ECOM_ORDER_STATUS = {
  ALL: -1,
  NEW: 0,
  ACCEPTED: 1,
  CONFIRMED: 2,
  DELIVERED: 3,
  PARTIALLY_DELIVERED: 4,
  AWAITING_APPROVAL: 5,
  REJECTED: 6,
  PENDING_DEALER_APPROVAL: 7,
  DELAYED: 8,
  CANCELED: 9,
  ASSET_MIGRATION: 10,
  CREDIT_REJECTED: 66,
  PRICE_CHANGED: 67,
  ERROR: 99,
}
